import { render, staticRenderFns } from "./PackageTable.vue?vue&type=template&id=e2f67460&scoped=true"
import script from "./PackageTable.vue?vue&type=script&lang=js"
export * from "./PackageTable.vue?vue&type=script&lang=js"
import style0 from "./PackageTable.vue?vue&type=style&index=0&id=e2f67460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f67460",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PzImage: require('/drone/src/components/PzImage/index.vue').default})
